import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { ILogin } from '../model/login';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { EncryptDecryptService } from '../services/encryptdecrypt.service';
import { LOGIN_INVALID_CRDENTIALS_ERROR , SOMETHING_WENT_WRONG , LOGIN_CRDENDTIALS_NOT_FOUND} from '../appConstant';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  security_salt: any;

  constructor(private _authenticationService: AuthenticationService, private router: Router,private encryptDecryptService: EncryptDecryptService) { }
  userlogin: ILogin;
  ngOnInit() {
  }

  // This method used for admin login
  // login(loginForm: NgForm) {
  //   //this.loading = true;   
  //   if((loginForm.value.username) || (loginForm.value.password)){
  //     console.log('loginForm.value.username ', loginForm.value.username);
  //     this._authenticationService.login(loginForm.value.username, loginForm.value.password)
  //     .subscribe(
  //       data => {
  //         if (data.returnCode == 0) {
  //           localStorage.setItem('currentUser', JSON.stringify({ token: data.responsetoken, userDetail: data.response.userDetail }));
  //           this.router.navigate(['admindashboard']);
  //         }
  //         else {
  //           if((data.returnCode == 1) && (data.returnMsg != '')){
  //             alert(data.returnMsg);
  //           }
  //           else{
  //             alert(LOGIN_INVALID_CRDENTIALS_ERROR);
  //           }
  //         }
  //       },
  //       error => {
  //         // this.alertService.error(error);
  //         // this.loading = false;         
  //         alert(SOMETHING_WENT_WRONG)
  //       });
  //   }
  //   else{
  //     console.log('else block');
  //     alert(LOGIN_CRDENDTIALS_NOT_FOUND);
  //   }
    
  // }


  // This method used for admin login
  login(loginForm: NgForm) {
    //this.loading = true;   
    if((loginForm.value.username) || (loginForm.value.password)){
      
      this.security_salt = this.encryptDecryptService.security_salt;
      let encryptUsername = this.encryptDecryptService.set(this.security_salt, loginForm.value.username);
      let encryptPassword = this.encryptDecryptService.set(this.security_salt, loginForm.value.password);
      loginForm.value.username = encryptUsername;
      loginForm.value.password = encryptPassword;

      console.log('loginForm.value.username ', loginForm.value.username , loginForm.value.password);
      this._authenticationService.login(loginForm.value.username, loginForm.value.password)
      .subscribe(
        data => {
          if (data.returnCode == 0) {
            localStorage.setItem('currentUser', JSON.stringify({ token: data.responsetoken, userDetail: data.response.userDetail }));
            localStorage.setItem('loggingStatus', 'yes');
            this.router.navigate(['admindashboard']);
          }
          else {
            if((data.returnCode == 1) && (data.returnMsg != '')){
              alert(data.returnMsg);
            }
            else{
              alert(LOGIN_INVALID_CRDENTIALS_ERROR);
            }
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(SOMETHING_WENT_WRONG)
        });
    }
    else{
      console.log('else block');
      alert(LOGIN_CRDENDTIALS_NOT_FOUND);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts